import React from "react";
import { Link } from "react-router-dom";
import { DASHBOARD } from "../../utils/RouteConstant";

const PageNotFound = () => {
  return (
    <section className="flex flex-col p-10 items-center justify-center h-screen bg-white font-serif">
      <div
        className="relative flex items-center justify-center w-full h-full bg-cover bg-center"
        style={{ backgroundImage: "url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif)"}}
      >
        <h1 className="text-8xl text-white">404</h1>
      </div>

      <div className="text-center ">
        <h3 className="text-3xl">Look like you're lost</h3>
        <p className="mt-2 text-lg">
          The page you are looking for is not available!
        </p>
        <Link
          to={DASHBOARD}
          className="mt-4 inline-block px-6 py-3 text-white bg-green-600 rounded hover:bg-green-500 transition duration-300"
        >
          Go to Home
        </Link>
      </div>
    </section>
  );
};

export default PageNotFound;
